import { bytesToBinary } from './bytes.js';

export type DocFormat = 'html' | 'mhtml' | 'webarchive' | 'pdf' | 'image' | 'unknown';

/** PNG, JPEG, GIF, WebP ve HEIC/AVIF imzaları; telefonda sayfanın ekran görüntüsü yükleniyor. */
const isImage = (h: string): boolean =>
  h.startsWith('\x89PNG\r\n\x1a\n') || h.startsWith('\xFF\xD8\xFF') || /^GIF8[79]a/.test(h) ||
  (h.startsWith('RIFF') && h.slice(8, 12) === 'WEBP') || /^ftyp(hei[cfsx]|hevc|mif1|msf1|avif)/.test(h.slice(4, 12));
const IMAGE_EXT = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif', 'avif']);

export function detectFormat(bytes: Uint8Array, fileName: string): DocFormat {
  const head = bytesToBinary(bytes.subarray(0, 4096));
  if (head.startsWith('bplist00')) return 'webarchive';
  if (head.startsWith('%PDF')) return 'pdf';
  if (isImage(head)) return 'image';
  // bayt-birebir çözümde UTF-8 BOM üç karakter (EF BB BF) olarak görünür
  const trimmed = head.replace(/^\xEF\xBB\xBF/, '').trimStart();
  if (/^(From:|MIME-Version:|Snapshot-Content-Location:|Subject:|Date:)/i.test(trimmed) || /Content-Type:\s*multipart\/related/i.test(head)) return 'mhtml';
  if (trimmed.startsWith('<')) return 'html';
  const ext = fileName.toLowerCase().split('.').pop() ?? '';
  if (ext === 'html' || ext === 'htm') return 'html';
  if (ext === 'mhtml' || ext === 'mht') return 'mhtml';
  if (ext === 'webarchive') return 'webarchive';
  if (ext === 'pdf') return 'pdf';
  if (IMAGE_EXT.has(ext)) return 'image';
  return 'unknown';
}
